import { Component, OnInit, inject } from '@angular/core';
import { CardComponent } from '../../../../shared/components/card/card.component';
import { AsyncPipe } from '@angular/common';
import { PrecipitationPipe } from '../../pipes/precipitation.pipe';
import { RelativeDatePipe } from '../../../../shared/pipes/relative-date.pipe';
import { TemperaturePipe } from '../../pipes/temperature.pipe';
import { TextWithIconComponent } from '../../../../shared/components/text-with-icon/text-with-icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { WeatherService } from '../../../../core/services/weather.service';
import { Weather } from '@birco/rainmesh-api';
import { combineLatest, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectDeviceById } from '../../../devices/state/device.selectors';
import { DeviceActions } from '../../../devices/state/device.actions';
import { LocalizedDatePipe } from '../../../../shared/pipes/localized-date.pipe';
import { LocalizedPercentPipe } from '../../../../shared/pipes/localized-percent.pipe';
import { LocalizedNumberPipe } from '../../../../shared/pipes/localized-number.pipe';
import { WindPipe } from '../../pipes/wind.pipe';

@Component({
  selector: 'app-weather-dashboard-card',
  imports: [
    CardComponent,
    AsyncPipe,
    LocalizedDatePipe,
    LocalizedPercentPipe,
    LocalizedNumberPipe,
    PrecipitationPipe,
    RelativeDatePipe,
    TemperaturePipe,
    TextWithIconComponent,
    TranslatePipe,
    WindPipe,
  ],
  templateUrl: './weather-dashboard-card.component.html',
  styleUrl: './weather-dashboard-card.component.scss',
})
export class WeatherDashboardCardComponent implements OnInit {
  private _weatherService = inject(WeatherService);
  private store = inject(Store);

  loading$ = this._weatherService.loading$();

  weather$ = combineLatest([
    this._weatherService.location$(),
    this._weatherService.currentWeather$(),
    this._weatherService.todayForecast$(),
    this._weatherService
      .extendedForecast$()
      .pipe(map((arr) => arr.slice(0, 1))),
  ]).pipe(
    map(([location, now, today, extendedForecast]) => {
      if (location && now && today && extendedForecast) {
        return {
          location,
          now,
          today,
          extendedForecast,
        };
      } else {
        return null;
      }
    }),
  );

  ngOnInit() {
    this.store.dispatch(
      DeviceActions.public.loadDeviceById({
        id: '76ef4018-5e83-4915-b35a-9449b3869963',
      }),
    );
  }

  getRainHint(weather: Weather): { error: boolean; text: string } | undefined {
    return this._weatherService.utils.getRainHint(weather);
  }

  getWeatherIcon(weather: Weather): string {
    return this._weatherService.utils.getWeatherIcon(weather);
  }

  getGeoInfo(lat: number, lon: number): string {
    return this._weatherService.utils.getGeoInfo(lat, lon);
  }
}
